export interface PauseMenuButtonProps {
  onOpen: () => void;
}

/** Visible ☰/pause button for touch users, who have no Esc key to open the
 * pause menu. Lives in the game screen's CHROME (absolutely positioned,
 * same "outside `.stage-top`/`.game-body` flow" technique as MuteButton --
 * see index.css `.pause-menu-button` and MuteButton's own comment) -- it
 * is never a sibling inside the boxes useGameLayout.ts measures, so it can
 * never perturb the maze canvas budget, and it never composites over
 * `.game-canvas` itself (top-left corner over the HUD/chrome strip only,
 * the mirror position of MuteButton's top-right). >=44x44 on touch per
 * SPEC.md §5. */
export function PauseMenuButton({ onOpen }: PauseMenuButtonProps): JSX.Element {
  return (
    <button
      type="button"
      className="pause-menu-button"
      onClick={onOpen}
      aria-label="Pause and open menu"
      data-testid="pause-menu-button"
    >
      <span aria-hidden="true">&#9776;</span>
    </button>
  );
}
